module.exports = __webpack_public_path__ + "public/img/变现猫@1x.600f8ba3.png";